import { useTranslation } from 'react-i18next';

const MAIN_SITE_URL = 'https://kaspreadsheet.com';

export default function Hero() {
  const { t } = useTranslation();

  return (
    <section className="relative min-h-[90vh] flex items-center justify-center overflow-hidden">
      {/* Background image */}
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Curated%20premium%20fashion%20flatlay%20featuring%20designer%20sneakers%20hoodies%20caps%20and%20leather%20accessories%20on%20a%20soft%20neutral%20studio%20background%20high%20end%20editorial%20product%20photography%20soft%20natural%20light%20warm%20tones&width=1920&height=1080&seq=hero-fashion-01&orientation=landscape"
          alt="CSSBuy Spreadsheet fashion products"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/50" />
      </div>

      {/* Content */}
      <div className="relative z-10 max-w-5xl mx-auto px-4 sm:px-6 lg:px-8 text-center py-24">
        <h1 className="text-3xl sm:text-4xl md:text-5xl lg:text-6xl font-bold text-white leading-tight mb-6 animate-fade-in">
          {t('hero_title')}
        </h1>
        <p className="text-base sm:text-lg md:text-xl text-white/90 max-w-3xl mx-auto mb-10 leading-relaxed animate-fade-in" style={{ animationDelay: '0.2s' }}>
          {t('hero_subtitle')}
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-12 animate-fade-in" style={{ animationDelay: '0.4s' }}>
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-4 bg-primary-500 hover:bg-primary-600 text-white rounded-full font-semibold text-base transition-all shadow-lg hover:shadow-xl whitespace-nowrap"
          >
            {t('hero_cta_primary')}
          </a>
          <a
            href={MAIN_SITE_URL}
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-4 bg-white/10 hover:bg-white/20 backdrop-blur-sm text-white border border-white/30 rounded-full font-semibold text-base transition-all whitespace-nowrap"
          >
            {t('hero_cta_secondary')}
          </a>
        </div>

        {/* Trust badges */}
        <div className="flex flex-wrap items-center justify-center gap-x-6 gap-y-2 text-white/80 text-sm animate-fade-in" style={{ animationDelay: '0.6s' }}>
          <span className="flex items-center gap-1">
            <i className="ri-check-line text-primary-300" /> {t('hero_trust_1')}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-check-line text-primary-300" /> {t('hero_trust_2')}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-check-line text-primary-300" /> {t('hero_trust_3')}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-check-line text-primary-300" /> {t('hero_trust_4')}
          </span>
          <span className="flex items-center gap-1">
            <i className="ri-check-line text-primary-300" /> {t('hero_trust_5')}
          </span>
        </div>
      </div>

      {/* Scroll indicator */}
      <div className="absolute bottom-6 left-1/2 -translate-x-1/2 animate-bounce text-white/60">
        <i className="ri-arrow-down-line text-2xl" />
      </div>
    </section>
  );
}